export const MAX_DATE_RANGE_IN_DAYS_PER_LOCKED_CACHE = 110;
export const MAX_RETRIES_TO_LOAD_CALENDAR_EVENT_FROM_SERVER = 3;
export const MAX_RETRIES_TO_LOAD_EVENTS_FOR_DATERANGE = 1; /* retry once (total 2 attempts) if the service call fails */
